import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-8 max-w-3xl">
        <Card>
          <CardHeader>
            <CardTitle className="font-display text-3xl">Integritetspolicy</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-olive max-w-none">
            <p className="text-muted-foreground">
              Senast uppdaterad: {new Date().toLocaleDateString('sv-SE')}
            </p>

            <h2 className="font-display text-xl mt-6 mb-3">Vilka uppgifter samlar vi in?</h2>
            <p>När du skapar ett konto på Korsordslexikon samlar vi in:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>E-postadress</strong> – för inloggning och kontohantering</li>
              <li><strong>Visningsnamn</strong> – visas på dina inlägg i forumet</li>
              <li><strong>Tidpunkt för GDPR-samtycke</strong> – juridiskt krav</li>
            </ul>

            <h2 className="font-display text-xl mt-6 mb-3">Hur använder vi dina uppgifter?</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>För att möjliggöra inloggning till forumet</li>
              <li>För att visa ditt namn på dina foruminlägg</li>
              <li>Vi säljer eller delar <strong>aldrig</strong> dina uppgifter med tredje part</li>
            </ul>

            <h2 className="font-display text-xl mt-6 mb-3">Dina rättigheter</h2>
            <p>Enligt GDPR har du rätt att:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Få tillgång</strong> till dina personuppgifter</li>
              <li><strong>Rätta</strong> felaktiga uppgifter</li>
              <li><strong>Radera</strong> ditt konto och alla tillhörande uppgifter</li>
              <li><strong>Exportera</strong> dina data</li>
            </ul>

            <h2 className="font-display text-xl mt-6 mb-3">Radering av konto</h2>
            <p>
              Du kan när som helst radera ditt konto via dina kontoinställningar. 
              När du raderar ditt konto tas följande bort permanent:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Din e-postadress och profil</li>
              <li>Alla dina forumtrådar och svar</li>
            </ul>
            <p className="mt-2">
              Denna åtgärd kan <strong>inte</strong> ångras.
            </p>

            <h2 className="font-display text-xl mt-6 mb-3">Kontakt</h2>
            <p>
              Har du frågor om hur vi hanterar dina uppgifter? Kontakta oss via forumet.
            </p>
          </CardContent>
        </Card>
      </main>

      <Footer />
    </div>
  );
}